import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState, selectAuthState, selectDoctorState } from '../../../store/app.states';
import { Observable } from 'rxjs';
import { Patient } from '../../../model/user/Patient';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ErrorDialogComponent } from '../../user-actions/error-dialog/error-dialog.component';
import { QuestionnaireService } from '../../../services/questionnaire.service';
import {
  GetJobs,
  GetPatients, GetQuestionnairesClinicalHBI, GetQuestionnairesClinicalPRISM,
  GetQuestionnairesClinicalSCCAI,
  GetQuestionnairesEORTC,
  GetQuestionnairesEQ5D5L,
  GetQuestionnairesHADS,
  GetQuestionnairesHBI,
  GetQuestionnairesIBDDisk,
  GetQuestionnairesIPAQSF,
  GetQuestionnairesMIAHCD,
  GetQuestionnairesMIAHUC,
  GetQuestionnairesMMAS8,
  GetQuestionnairesPatientSCCAI,
  GetQuestionnairesPHQ9, GetQuestionnairesPRISM,
  GetQuestionnairesPSQI,
  GetQuestionnairesSIBDQ,
  GetQuestionnairesIBDQ, // QUESTIONARIO AGGIUNTO DA CATERINA
  GetQuestionnairesTSQM,
  GetQuestionnairesWPAI,
  GetQuestionnairesLARS,
  GetQuestionnairesDataConsent
} from '../../../store/actions/doctor.actions';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { isNumeric } from 'rxjs/util/isNumeric';
import { JobModel } from '../../../model/job/JobModel';
import { QuestionnaireAddDialogComponent } from './questionnaire-add-dialog';
import { ConfirmDialogComponent } from '../../user-actions/confirm-dialog/confirm-dialog.component';
import { NameAndDaysQuestionnaire } from '../../../model/user/NameAndDaysQuestionnaire';

@Component({
  selector: 'app-patient-questionnaire-panel',
  templateUrl: './patient-questionnaire-panel.component.html',
  styleUrls: ['./patient-questionnaire-panel.component.css']
})

export class PatientQuestionnairePanelComponent implements OnInit {

  patientSSN: string;
  getAuthState: Observable<any>;
  getDoctorState: Observable<any>;
  dataSource;
  dataSourceClinical;
  //// user state
  isAuthenticated: boolean;
  user = null;
  errorMessage = null;
  //// doctor state
  resultsEORTC = null;
  resultsEQ5D5L = null;
  resultsHBI = null;
  resultsIBDDisk = null;
  resultsSIBDQ = null;
  resultsTSQM = null;
  resultsWPAI = null;
  // nameAndDaysReady serve per evitare che escano errori nella console dovuti da nameAndDaysQuestionnaireMap non ancora caricato
  nameAndDaysReady = false;

  //

  // Patient to set questionnaires
  patient: Patient;

  title = 'Questionari';
  destination = 'patients-control-panel';
  questionnaires: string[] = [
    'CLINICAL-HBI',
    'CLINICAL-SCCAI',
    'CLINICAL-PRISM',
    // 'EORTC-QLQ',
    'EQ5D5L',
    // 'HADS',
    'HBI',
    'IBD-DISK',
    'IPAQ-SF',
    'MIAH-CD',
    'MIAH-UC',
    'MMAS8',
    'PATIENT-SCCAI',
    'PHQ9',
    'PRISM',
    'PSQI',
    // 'SIBDQ',
    'IBDQ', // QUESTIONARIO AGGIUNTO AL POSTO DI SIBDQ
    'TSQM',
    'WPAI',
    'LARS',
    'DATA-CONSENT'];
  unselectedQuestionnaires: string[] = [];
  // lastTimerSet assume come valore il timer dell'ultimo questionario cambiato. In caso il cambio vada a buon fine
  // verrà inserito nella mappa.
  lastTimerSet;
  nameAndDaysQuestionnaireMap; // contiene <nome questionario, timer>

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  displayedColumns = ['type', 'open', 'completed', 'timer', 'actualFreq', 'sendNew', 'remove'];
  displayedColumnsForClinical = ['type', 'pendings', 'completed', 'sendNew', 'remove'];

  constructor(private router: Router,
    private store: Store<AppState>,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    private questionnaireService: QuestionnaireService,
    private snackBar: MatSnackBar) {

    this.getAuthState = this.store.select(selectAuthState);
    this.getDoctorState = this.store.select(selectDoctorState);
    // controlliamo nell'url da quale pagina arriviamo in modo da settare la variabile che fa funzionare
    // il tasto indietro nella toolbar
    this.route.params.subscribe(params => {
      this.patientSSN = params.ssn;
      if (params.back.localeCompare('global') === 0) {
        this.destination = 'patients-global-control-panel';
      } else if (params.back.localeCompare('inactive-patients-summary') === 0) {
        const doctorID = JSON.parse(localStorage.getItem('doctorID'));
        this.destination = 'inactive-patients-summary/' + doctorID;
      } else {
        this.destination = 'patients-control-panel';
      }
    });
  }

  ngOnInit(): void {
    this.setupUser();
    this.setupPatient();
    this.setupTable();
    this.setupPendings();
    this.dispatching();
    this.store.dispatch(new GetJobs(this.patientSSN));
    this.questionnaireService.getAllFrequencyQuestionnaires(this.patientSSN).subscribe(nameAndDays => {
      // this.nameAndDaysQuestionnaires = nameAndDays;
      this.nameAndDaysQuestionnaireMap = new Map();
      nameAndDays.forEach(nd => this.nameAndDaysQuestionnaireMap[nd.questionnaireName] = nd.days);
      this.nameAndDaysReady = true;
    });
    document.addEventListener('notification', () => {
      setTimeout(() => {
        this.dispatching();
        this.setupPendings();
      }, 200);
    });
  }

  setupPendings() {
    const doctorID = JSON.parse(localStorage.getItem('doctorID'));
    const clinicalQuestionnaires = this.patient.questionnaires.filter(questionnaire => questionnaire.includes('CLINICAL'));
    clinicalQuestionnaires.forEach(questionnaire => {
      this.questionnaireService.getAllClinicalPendings(doctorID, this.patientSSN, questionnaire.toUpperCase()).subscribe(p => {
        localStorage.setItem('pendings-' + questionnaire.toLowerCase(), JSON.stringify(p));
      });
    });
  }


  setupUser() {
    this.getAuthState.subscribe((state) => {
      this.isAuthenticated = state.isAuthenticated;
      this.user = JSON.parse(localStorage.getItem('user'));
      this.errorMessage = state.errorMessage;
    });
  }

  setupPatient() {
    const patients: Patient[] = JSON.parse(localStorage.getItem('patients'));
    this.patient = patients.find(p => p.ssn.localeCompare(this.patientSSN) === 0);
    console.log(this.patient);
    this.questionnaires.forEach(q => {
      if (this.patient.questionnaires.find(quest => quest.localeCompare(q) === 0) === undefined) {
        this.unselectedQuestionnaires.push(q);
      }
    });
  }

  setupTable() {
    this.paginator._intl.itemsPerPageLabel = 'Questionari per pagina';
    this.dataSource = new MatTableDataSource<string>(this.patient.questionnaires.sort().filter(q => !q.includes('CLINICAL')));
    this.dataSource.paginator = this.paginator;
    this.dataSourceClinical = new MatTableDataSource<string>(this.patient.questionnaires.sort().filter(q => q.includes('CLINICAL')));
  }

  dispatching() {
    this.patient.questionnaires.forEach(type => {
      const q = type.toLowerCase();
      switch (q) {
        case 'clinical-sccai':
          this.store.dispatch(new GetQuestionnairesClinicalSCCAI(this.patientSSN));
          break;
        case 'clinical-hbi':
          this.store.dispatch(new GetQuestionnairesClinicalHBI(this.patientSSN));
          break;
        case 'clinical-prism':
          this.store.dispatch(new GetQuestionnairesClinicalPRISM(this.patientSSN));
          break;
        case 'eortc-qlq':
          this.store.dispatch(new GetQuestionnairesEORTC(this.patientSSN));
          break;
        case 'eq5d5l':
          this.store.dispatch(new GetQuestionnairesEQ5D5L(this.patientSSN));
          break;
        case 'hads':
          this.store.dispatch(new GetQuestionnairesHADS(this.patientSSN));
          break;
        case 'hbi':
          this.store.dispatch(new GetQuestionnairesHBI(this.patientSSN));
          break;
        case 'ibd-disk':
          this.store.dispatch(new GetQuestionnairesIBDDisk(this.patientSSN));
          break;
        case 'ipaq-sf':
          this.store.dispatch(new GetQuestionnairesIPAQSF(this.patientSSN));
          break;
        case 'miah-cd':
          this.store.dispatch(new GetQuestionnairesMIAHCD(this.patientSSN));
          break;
        case 'miah-uc':
          this.store.dispatch(new GetQuestionnairesMIAHUC(this.patientSSN));
          break;
        case 'mmas8':
          this.store.dispatch(new GetQuestionnairesMMAS8(this.patientSSN));
          break;
        case 'patient-sccai':
          this.store.dispatch(new GetQuestionnairesPatientSCCAI(this.patientSSN));
          break;
        case 'phq9':
          this.store.dispatch(new GetQuestionnairesPHQ9(this.patientSSN));
          break;
        case 'prism':
          this.store.dispatch(new GetQuestionnairesPRISM(this.patientSSN));
          break;
        case 'psqi':
          this.store.dispatch(new GetQuestionnairesPSQI(this.patientSSN));
          break;
        case 'sibdq':
          this.store.dispatch(new GetQuestionnairesSIBDQ(this.patientSSN));
          break;
        case 'ibdq':
          console.log('sono entrato');
          this.store.dispatch(new GetQuestionnairesIBDQ(this.patientSSN)); // QUESTIONARIO AGGIUNTO DA CATERINA
          break;
        case 'tsqm':
          this.store.dispatch(new GetQuestionnairesTSQM(this.patientSSN));
          break;
        case 'wpai':
          this.store.dispatch(new GetQuestionnairesWPAI(this.patientSSN));
          break;
        case 'lars':
          this.store.dispatch(new GetQuestionnairesLARS(this.patientSSN));
          break;
        case 'data-consent':
          this.store.dispatch(new GetQuestionnairesDataConsent(this.patientSSN));
          break;
      }
    });
  }

  openErrorDialog(message: string): void {
    const dialogRef = this.dialog.open(ErrorDialogComponent, {
      width: '500px',
      height: '270px',
      data: message
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('Finestra chiusa');
    });
  }

  addQuestionnaireDialog(): void {
    const message = 'Questionari disponibili';
    const dialogRef = this.dialog.open(QuestionnaireAddDialogComponent, {
      width: '600px',
      height: '500px',
      data: { message, values: this.unselectedQuestionnaires }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === undefined) {
        this.openErrorDialog('Non hai effettuato alcuna selezione!');
      } else {
        result.forEach(r => {
          if (this.patient.questionnaires.find(res => res.localeCompare(r) === 0) === undefined) {
            this.patient.questionnaires.push(r);
          }
        });
        this.questionnaireService.setQuestionnaires(this.patientSSN, this.patient.questionnaires)
          .subscribe(res => {
            if (res.status === 200) {
              this.store.dispatch(new GetPatients());
              this.dataSource.data = this.patient.questionnaires.slice().sort().filter(q => !q.includes('CLINICAL'));
              this.dataSourceClinical.data = this.patient.questionnaires.slice().sort().filter(q => q.includes('CLINICAL'));
              this.dispatching();
              document.dispatchEvent(new CustomEvent('update-questionnaires', {
                bubbles: true
              }));
            }
          },
            error => {
              console.log(error);
              this.openErrorDialog('Qualcosa è andato storto. Le modifiche non verranno salvate.');
            });
        this.patient.questionnaires.forEach(q => {
          this.unselectedQuestionnaires = this.unselectedQuestionnaires.filter(quest => quest.localeCompare(q) !== 0);
        });
        this.store.dispatch(new GetJobs(this.patientSSN));
      }
      console.log('Finestra chiusa');
    });
  }

  goToQuestionnaire(name: string) {
    if (this.destination.localeCompare('patients-global-control-panel') === 0) {
      this.router.navigateByUrl('/patient-questionnaires-show/' + this.patientSSN + '/' + name.toLowerCase() + '/global');
    } else {
      this.router.navigateByUrl('/patient-questionnaires-show/' + this.patientSSN + '/' + name.toLowerCase() + '/local');
    }
  }

  goToClinicalPendings(name: string) {
    const doctorID = JSON.parse(localStorage.getItem('doctorID'));
    if (this.destination.localeCompare('patients-global-control-panel') === 0) {
      // tslint:disable-next-line:max-line-length
      this.router.navigateByUrl('/patient-clinical-pendings/' + doctorID + '/' + this.patientSSN + '/' + name.toLowerCase() + '/global');
    } else {
      // tslint:disable-next-line:max-line-length
      this.router.navigateByUrl('/patient-clinical-pendings/' + doctorID + '/' + this.patientSSN + '/' + name.toLowerCase() + '/local');
    }
  }

  openRemoveQuestionnaireDialog(questionnaire: string) {

    console.log(questionnaire);

    const results = JSON.parse(localStorage.getItem(questionnaire.toLowerCase()));
    console.log(results);

    if (results !== null && results !== undefined) {
      if (results.length > 0) {
        const message = 'Sono presenti questionari ' + questionnaire + ' compilati dal paziente. Vuoi confermare?';
        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
          width: '500px',
          height: '265px',
          data: message
        });

        dialogRef.afterClosed().subscribe(result => {
          if (result === 'SI') {
            this.removeQuestionnaire(questionnaire);
          }
        });
      } else {
        this.removeQuestionnaire(questionnaire);
      }
    } else {
      this.removeQuestionnaire(questionnaire);
    }
  }

  removeQuestionnaire(questionnaire: string) {
    this.questionnaireService.removeQuestionnaire(this.patientSSN, questionnaire)
      .subscribe(res => {
        if (res.status === 200) {
          this.store.dispatch(new GetPatients());
          this.patient.questionnaires.forEach((q, index) => {
            if (q.localeCompare(questionnaire) === 0) {
              this.patient.questionnaires.splice(index, 1);
            }
          });

          this.unselectedQuestionnaires.push(questionnaire);
          this.unselectedQuestionnaires.sort();
          this.dataSource.data = this.patient.questionnaires.slice().sort().filter(q => !q.includes('CLINICAL'));
          this.dataSourceClinical.data = this.patient.questionnaires.slice().sort().filter(q => q.includes('CLINICAL'));
          localStorage.removeItem(questionnaire.toLowerCase());
          this.dispatching();
          document.dispatchEvent(new CustomEvent('update-questionnaires', {
            bubbles: true
          }));
        }
      },
        error => {
          console.log(error);
          this.openErrorDialog('Qualcosa è andato storto. Le modifiche non verranno salvate.');
        });
  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 2000,
    });
  }

  sendNew(questionnaire) {
    this.questionnaireService.createAndSend(questionnaire, this.patientSSN).subscribe(d => {
      if (d.status === 200) {
        this.openSnackBar('Questionario inviato con successo!', 'Chiudi');
      }
    },
      error => {
        this.openErrorDialog('È consentito l\'invio di massimo un questionario al giorno.');
        console.log(error);
      });
  }

  addJobDialog(questionnaire: string) {
    const jobs: JobModel[] = JSON.parse(localStorage.getItem('jobs'));

    let job: JobModel = null;

    if (jobs !== null && jobs !== undefined) {
      jobs.forEach(j => {
        if (j.id.includes(questionnaire)) {
          job = j;
        }
      });
    }

    let timer = 0;

    if (job !== null) {
      timer = job.timer;
    }

    const dialogRef = this.dialog.open(AddJobDialogComponent, {
      width: '600px',
      height: '400px',
      data: { questionnaire, currentTimer: timer }
    });

    dialogRef.afterClosed().subscribe(result => {
      const del = 'Elimina';
      if (del.localeCompare(result) === 0) {
        this.questionnaireService.killJob(questionnaire, this.patientSSN).subscribe(r => {
          if (r.status === 200) {
            this.openSnackBar('Eliminato correttamente il timer!', 'Chiudi');
            this.store.dispatch(new GetJobs(this.patientSSN));
          }
        },
          error => {
            console.log(error);
            this.openErrorDialog('Qualcosa è andato storto. Le modifiche non verranno salvate.');
          });
      } else {
        const res: number = parseInt(result, 10);
        if (isNumeric(res) && res > 0) {
          this.lastTimerSet = res;
          const toSend = res * 24 * 60 * 60;  // refactoring in days
          console.log('adding job');
          this.questionnaireService.addJob(questionnaire, this.patientSSN, toSend).subscribe(r => {
            if (r.status === 200) {
              this.openSnackBar('Impostato correttamente il timer!', 'Chiudi');
              this.store.dispatch(new GetJobs(this.patientSSN));
              this.nameAndDaysQuestionnaireMap[questionnaire] = this.lastTimerSet;
            }
          },
            error => {
              console.log(error);
              this.openErrorDialog('Qualcosa è andato storto. Le modifiche non verranno salvate.');
            });
        }
      }
    });
  }

  /*calcFrequency(questionnaire: string): any {
    console.log('1) ');
    console.log(this.nameAndDaysQuestionnaires);
    if (this.nameAndDaysQuestionnaires !== null
        && this.nameAndDaysQuestionnaires !== undefined) {
      return this.nameAndDaysQuestionnaires.filter(q => {
        if (q.questionnaireName === questionnaire) {
          return true;
        } else {
          return false;
        }
      }).map(q => q.days);
    } else {
      return '-';
    }
  }*/

  calcPendings(questionnaire: string): number {
    const len = JSON.parse(localStorage.getItem('pendings-' + questionnaire.toLowerCase()));
    return len !== null && len !== undefined ? len.length : 0;
  }

  calcCompletedAndNotRead(questionnaire: string): number {
    const questionnaires = JSON.parse(localStorage.getItem(questionnaire.toLowerCase()));
    return questionnaires !== null && questionnaires !== undefined ? questionnaires.filter(q => !q.read).length : 0;
  }

  calcCompleted(questionnaire: string): number {
    const questionnaires = JSON.parse(localStorage.getItem(questionnaire.toLowerCase()));
    return questionnaires !== null && questionnaires !== undefined ? questionnaires.length : 0;
  }
}

///////////// TIMER JOB /////

export interface CurrentJobInterface {
  questionnaire: string;
  currentTimer: number;
}

@Component({
  selector: 'app-add-job-dialog',
  templateUrl: './questionnaire-add-job-dialog.html',
  styleUrls: ['./questionnaire-add-job-dialog.css']
})
export class AddJobDialogComponent implements OnInit {

  notFocused = false;
  frequencyForm: FormGroup;
  killJob = 'Elimina';
  currentTimer: number;

  constructor(public dialogRef: MatDialogRef<AddJobDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CurrentJobInterface) { }

  ngOnInit(): void {
    this.currentTimer = this.data.currentTimer / (3600 * 24); // refactoring in days
    this.frequencyForm = new FormGroup({
      frequency: new FormControl(this.currentTimer, [Validators.required, Validators.min(1), Validators.max(365)]),
    });
  }

  cancel() {
    this.dialogRef.close();
  }
}
